import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_SIGNING_REQUEST_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> asks you to sign until <b>{dueDate}</b>.`,
  email: {
    ctaKey: 'sign_now',
  },
};
